import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from 'react';
import { useForm } from "react-hook-form";

import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle
} from "@/components/ui/dialog";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { AddMemberModalProps, AddMemberModalSchemaType, addMemberSchema } from '.';


export function AddMemberModal({open, onOpenChange, onSubmitHandler}: AddMemberModalProps) {
    const formOptions = { resolver: zodResolver(addMemberSchema) };
    const form = useForm<AddMemberModalSchemaType>(formOptions);

    useEffect(() => {
        if(open) {
            form.reset({
                email: ""
            });
        }
    }, [form, open])

    return (
        <Dialog open={open} onOpenChange={onOpenChange} defaultOpen={false}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>
                        <div className="p-0 m-0 text-lg font-bold text-start">Add Organization Member</div>
                    </DialogTitle>
                </DialogHeader>

                <Form {...form}>
                    <form action="">
                        <FormField
                            control={form.control}
                            name='email'
                            render={({ field }) => (
                                <FormItem>
                                    <FormLabel>Email</FormLabel>
                                    <FormControl>
                                        <Input {...field}/>
                                    </FormControl>
                                    <FormMessage/>
                                </FormItem>
                            )}
                        />
                    </form>
                </Form>

                <DialogFooter>
                    <div className="flex items-stretch justify-end m-0 sm:space-x-2 max-sm:flex-col max-sm:space-y-2">
                        <Button size="sm" variant="secondary" onClick={() => onOpenChange(false)}>Cancel</Button>
                        <Button size="sm" onClick={form.handleSubmit(onSubmitHandler)}>Submit</Button>
                    </div>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
